import axios from "axios";
import { useEffect, useRef, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { API_URL } from "../../ConstVariable";
import { MyContext } from "../context/ContextProvider";
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import AudioPlayer from 'material-ui-audio-player';
import { Button as Button2 } from "@material-ui/core";
import "./ChatFolder/Chat.css";
import "./Reactaudio.css";
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LoaderThreeDot from "../../Loader/LoaderThreeDot";
import AudioUnavailable from "../../Loader/audio-unavailable.png";
import { useAuth0 } from "@auth0/auth0-react";

const muiTheme = createMuiTheme({});

const AudioPlayerWidget = (props) => {

    const { user } = useAuth0();

    const { PauseAudio, ConversationDate } = useContext(MyContext);
    const [pause_audio, setPauseAudio] = PauseAudio;
    const [conversation_date, setConversationDate] = ConversationDate;
    const playerDispatch = useRef({ dispatch: null, player: null })



    const state = useSelector((state) => state);
    let selectedConversationId = state.SelectedConversationId;

    const [src, setSrc] = useState('')
    const [log, setLog] = useState('fetch')
    const [time, setTime] = useState(null)
    const { getAccessTokenSilently } = useAuth0();
    const GetAuthToken = async () => {
      const token = await getAccessTokenSilently();
      return token;
  };
    const fetch_conversation_timings = async() => {

        const token = await GetAuthToken();
        let search_date;
        if (props?.date != null) {
            search_date = props?.date
        }
        else {
            search_date = conversation_date;
        }

        axios({
            url: `${API_URL}/oi/api/v1/get-conversation-timings/${selectedConversationId}/${search_date}`, 
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true

        })
            .then((res) => {
                if (res.data != null && res.data.length > 0) {
                    setTime(res.data)
                }

            })
            .catch((error) => {
            })



    }
    useEffect(() => {
        fetch_conversation_timings()
    }, [conversation_date])

    useEffect(() => {
        if (selectedConversationId != null && ["MOBILE", "LANDLINE", "PRIVATE", "PBX"].includes(state.CallSource)) {
            axios
                .get(`${API_URL}/oi/api/twilio/audio/${selectedConversationId}`, {withCredentials: true})
                // .get("https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav"),
                

                .then((res) => {

                    if (res.data != null) {
                        setSrc(`${API_URL}/oi/api/twilio/audio/${selectedConversationId}`)
                        // setSrc('https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav')
                        // fetch_conversation_timings();
                        setLog(true)

                    }
                    else {
                        setLog(false)

                    }


                })
                .catch((error) => {
                    setLog(false)
                    // setSrc('https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav')
                    // fetch_conversation_timings();


                })

        }
        else {
            setLog(false)
        }
    }, [selectedConversationId]);

    const [audio, setAudio] = useState(Array.from(document.querySelectorAll("audio")).length == 1 ? Array.from(document.querySelectorAll("audio"))[0] : Array.from(document.querySelectorAll("audio"))[1])





    useEffect(() => {
        if (log == true && src != '') {
            setAudio(Array.from(document.querySelectorAll("audio")).length == 1 ? Array.from(document.querySelectorAll("audio"))[0] : Array.from(document.querySelectorAll("audio"))[1])
        }
    }, [log, src, selectedConversationId, pause_audio])

    useEffect(() => {
        if (pause_audio == true) {
            audio?.pause();

        }
    }, [pause_audio]);



    function forward30Audio() {

        if (audio != null) {
            audio.currentTime += 30.0
        }
    }


    function backward30Audio() {
        if (audio != null) {
            audio.currentTime -= 30.0
        }

    }
    function forward10Audio() {
        if (audio != null) {
            audio.currentTime += 10.0
        }

    }


    function backward10Audio() {
        if (audio != null) {
            audio.currentTime -= 10.0
        }
    }

    const checkDuration = (time) => {
        let diff


        if (audio != null && audio?.currentTime < time) {
            diff = time - audio.currentTime;
            audio.currentTime += diff;
            playerDispatch.current.player.play()
        }
        else if (audio != null && audio?.currentTime > time) {
            diff = audio.currentTime - time;
            audio.currentTime -= diff;
            playerDispatch.current.player.play()



        }
        else {
            if (audio != null) {
                audio.currentTime = audio?.currentTime;
                playerDispatch.current.player.play()

            }


        }
        playerDispatch.current.dispatch({ type: 'PLAYER_STATUS_PLAY' })
    }

    const getPlayer = (currentPlayer, dispatch) => {
        playerDispatch.current.dispatch = dispatch
        playerDispatch.current.player = currentPlayer
    };


    return (
        <div
            style={{
                justifyContent: "center",
                display: "flex",
                backgroundColor: "white",
            }}
        >

            <div>
                {log == 'fetch' ? <div style={{ textAlign: 'center', width: '300px', borderRadius: '10px', background: "rgba(0, 0, 0, 0.03)", marginTop: '20px' }}><div style={{ marginBottom: '5px', marginTop: '5px', paddingTop: '10px' }}><LoaderThreeDot /></div><div style={{ paddingBottom: '10px' }}>Fetching Audio</div></div> : (log == false ? <div style={{ textAlign: 'center', width: '300px', borderRadius: '10px', background: "rgba(0, 0, 0, 0.03)", marginTop: '20px' }}><div style={{ marginBottom: '5px', marginTop: '5px', paddingTop: '10px' }}><img width={20} height={20} src={AudioUnavailable} /></div><div style={{ paddingBottom: '10px' }}>Audio Unavailable</div></div> : (log == true ?
                    <div>



                        <div style={{ width: '500px', height: '50px' }}>

                            <div>
                                <ThemeProvider theme={muiTheme}>
                                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && 
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', marginTop: '10px', marginRight: '90px', marginLeft: '120px' }}>
                                            {time != null && <>
                                                {time[2].contact_no != null && <><Button2 onClick={() => { checkDuration(time[2].contact_no) }} style={{ background: 'rgba(0, 0, 0, 0.04)' }}><span>M</span></Button2></>}
                                                {time[0].first_name != null && <><Button2 onClick={() => { checkDuration(time[0].first_name) }} style={{ background: 'rgba(0, 0, 0, 0.04)', marginRight: '2px' }}><span>FN</span></Button2></>}
                                                {time[1].last_name != null && <> <Button2 onClick={() => { checkDuration(time[1].last_name) }} style={{ background: 'rgba(0, 0, 0, 0.04)', marginRight: '2px' }}><span>LN</span></Button2></>}
                                            </>}
                                        </div>
                                    }

                                    <AudioPlayer
                                        classs={"audio"}
                                        elevation={5}
                                        width="100%"
                                        variation="primary"
                                        spacing={3}
                                        volume={false}
                                        Rounded={true}
                                        autoplay={false}
                                        loop={false}
                                        download={user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" ? true : false}
                                        src={src}
                                        getPlayer={getPlayer}
                                        preload={audio != 'undefined' && (audio != null ? "auto" : "none")}

                                    >


                                    </AudioPlayer>


                                </ThemeProvider>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>

                                    <Button2 style={{ padding: '5px 0px 0px 0px', cursor: 'pointer' }} onClick={backward30Audio}><span><FastRewindIcon /></span></Button2>
                                    <Button2 style={{ padding: '5px 0px 0px 0px', cursor: 'pointer' }} onClick={backward10Audio}><span><KeyboardArrowLeftIcon /></span></Button2>
                                    <Button2 style={{ padding: '5px 0px 0px 0px', cursor: 'pointer' }} onClick={forward10Audio}><span><KeyboardArrowRightIcon /></span></Button2>
                                    <Button2 style={{ padding: '5px 0px 0px 0px', cursor: 'pointer' }} onClick={forward30Audio}><span><FastForwardIcon /></span></Button2>
                                </div>
                            </div>
                        </div>

                    </div>


                    : <div>Audio Unavailable</div>))}



            </div>

        </div>

    );
}



export default AudioPlayerWidget;
